import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import DigitalCharm from "./DigitalCharm";
import AccountInfo from "./AccountInfoPanel";
import Addresses from "./Addresses";
import PersonalProfile from "./PersonalProfile";
import AddCoinsModal from "../AddCoinsModal";
import PurchaseCoins from "./PurchaseCoin";
import Interest from "./Interest";
import UpConsultation from "./UpcomingConsultation";
import MyAppointment from "./MyAppointment";
import NatalChart from "../NatalChart";
import Commission from "../Commission";
import Wallet from "../Wallet";
import Plan from "../Plan";
import Unsubscribe from "./Unsubscribe";
import { useTranslation } from "react-i18next";
const Container = styled.div`
  display: flex;
  min-height: 100vh;
  height: auto;
  background-color: #171326;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

const Tab = styled.button`
  display: block;
  padding: 10px;
  text-align: left;
  background: ${(props) =>
    props.isActive
      ? "linear-gradient(to right, #DFBD69, #b7954d, #926F34)"
      : "#1B0E3C"};
  border: 1px solid ${(props) => (props.isActive ? "transparent" : "#DFBD69")};
  cursor: pointer;
  width: 100%;
  margin-bottom: 5px;
  color: ${(props) => (props.isActive ? "#1B0E3C" : "#DFBD69")};
  font-weight: ${(props) => (props.isActive ? "bold" : "normal")};
  transition: background 0.3s ease, color 0.3s ease;
  border-radius: 5px;

  @media (max-width: 768px) {
    text-align: center;
    padding: 15px;
    font-size: 16px;
  }

  &:hover {
    background: linear-gradient(to right, #DFBD69, #b7954d, #926F34);
    color: #1B0E3C;
    font-weight: bold;
    border-color: transparent;
  }
`;

const Tabs = styled.div`
  width: 200px;
  background-color: #171326;
  padding: 10px;
  border-right: 1px solid #DFBD69;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #DFBD69;
    padding: 0;
  }

  /* Phones reach these sections from the top bar's menu instead */
  @media (max-width: 768px) {
    display: none;
  }
`;

const Content = styled.div`
  padding: 20px;
  flex-grow: 1;
  background-color: #171326;
  overflow: visible;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const AccountPage = () => {
  const { t } = useTranslation();
  //const [activeTab, setActiveTab] = useState('accountInfo');
  const location = useLocation();
  const navigate = useNavigate();
  const [VSTATUS, setVSTATUS] = useState(null);
  const [commissionCoins, setCommissionCoins] = useState(0);
  const [gemCount, setGemCount] = useState(0);
  const [vvp, setVVP] = useState(null);
  const [vp, setVP] = useState(null);

  // Redirect to main if user is not logged in
  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!loggedIn) {
      // send them back to main/home if not authenticated
      navigate("/main", { replace: true });
    }
  }, [navigate]);

  // test
  // const userID = 14;
  // const userName = "RamJuntilla";
  const userID = localStorage.getItem("userID");
  const userName = localStorage.getItem("username");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              UserName: userName,
              ID: userID,
              UserToken: "",
              Token: {
                AccessToken:
                  "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              },
            }),
          }
        );

        const result = await response.json();
        if (response.ok && result.Profiles?.[0]) {
          const profile = result.Profiles[0];
          setVSTATUS(profile.VSTATUS);
          setCommissionCoins(profile.CommissionCoins || 0);
          setGemCount(profile.Coins || 0);
          // capture affiliate codes if present (match API fields used elsewhere)
          setVVP(
            profile.VVP_CODE || profile.VVP || profile.vvp || localStorage.getItem("vvp") || null,
          );
          setVP(
            profile.VP_CODE || profile.VP || profile.vp || localStorage.getItem("vp") || null,
          );
          return profile;
        } else {
          throw new Error(`Error: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        return null;
      }
    };

    fetchData();
    console.log("Fetched VSTATUS:", VSTATUS);
  }, [userID, userName]);

  const [activeTab, setActiveTab] = useState(() => {
    // Check if we have state from navigation and it includes setactiveTab
    if (location.state && location.state.setactiveTab) {
      return location.state.setactiveTab;
    }
    // Default to accountInfo if no state
    return "accountInfo";
  });

  useEffect(() => {
    if (location.state && location.state.setactiveTab) {
      setActiveTab(location.state.setactiveTab);
    }
  }, [location.state]);

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/main");
    }
  };

  const selectTab = (tab) => setActiveTab(tab);

  const openBaziCalculator = () =>
    window.open(
      "https://xianhefairy.com/download/Bazi_Calculator.html",
      "_blank",
      "noopener,noreferrer",
    );

  // Hand the same sections to the top bar, whose phone menu lists them
  const outletContext = useOutletContext();
  const setPageMenu = outletContext?.setPageMenu;
  useEffect(() => {
    if (!setPageMenu) return undefined;
    const sections = [
      { key: "accountInfo", label: t('accountInfo.accountInformation') },
      { key: "purchasecoin", label: t('accountInfo.purchaseGems') },
      { key: "interest", label: t('accountInfo.interestGroup') },
      { key: "appointments", label: t('accountInfo.appointmentHistory') },
      ...(VSTATUS ? [{ key: "commission", label: t('accountInfo.commission') }] : []),
    ].map((section) => ({
      ...section,
      active: activeTab === section.key,
      onSelect: () => setActiveTab(section.key),
    }));
    if (vp || vvp) {
      sections.push({
        key: "bazi",
        label: t("account.downloadBazi", { defaultValue: "Bazi Calculator" }),
        onSelect: openBaziCalculator,
      });
    }
    setPageMenu({ label: t('tryoutpage.account'), items: sections });
  }, [setPageMenu, activeTab, VSTATUS, vp, vvp, t]);

  // Leaving the account page takes its sections out of the top bar
  useEffect(() => {
    if (!setPageMenu) return undefined;
    return () => setPageMenu(null);
  }, [setPageMenu]);

  if (activeTab === "personalProfile") {
    return <PersonalProfile onBack={handleGoBack} />;
  }

  return (
    <Container>
      <Tabs>
        <Tab
          isActive={activeTab === "accountInfo"}
          onClick={() => selectTab("accountInfo")}
        >
          {t('accountInfo.accountInformation')}
        </Tab>
        {/* <Tab isActive={activeTab === 'digitalcharm'} onClick={() => setActiveTab('digitalcharm')}>
          My Amulet
        </Tab> */}
        <Tab
          isActive={activeTab === "purchasecoin"}
          onClick={() => selectTab("purchasecoin")}
        >
          {t('accountInfo.purchaseGems')}
        </Tab>
        <Tab
          isActive={activeTab === "interest"}
          onClick={() => selectTab("interest")}
        >
          {t('accountInfo.interestGroup')}
        </Tab>
        {/* <Tab isActive={activeTab === 'upcoming'} onClick={() => setActiveTab('upcoming')}>
          My Appointments
        </Tab> */}
        <Tab
          isActive={activeTab === "appointments"}
          onClick={() => selectTab("appointments")}
        >
          {t('accountInfo.appointmentHistory')}
        </Tab>
        {/* <Tab isActive={activeTab === 'commission'} onClick={() => setActiveTab('commission')}>
          Commission
        </Tab> */}
        {VSTATUS && (
          <Tab
            isActive={activeTab === "commission"}
            onClick={() => selectTab("commission")}
          >
            {t('accountInfo.commission')}
          </Tab>
        )}
        {/* <Tab isActive={activeTab === 'chart'} onClick={() => setActiveTab('chart')}>
          My NatalChart
        </Tab> */}
        {/* New Tabs */}
        {/* <Tab
          isActive={activeTab === "wallet"}
          onClick={() => selectTab("wallet")}
        >
          My Wallet
        </Tab> */}
        {/* <Tab
          isActive={activeTab === "plan"}
          onClick={() => selectTab("plan")}
        >
          My Plan
        </Tab> */}
        {/* <Tab
          isActive={activeTab === "unsubscribe"}
          onClick={() => selectTab("unsubscribe")}
        >
          {t('accountInfo.manageSubscriptions')}
        </Tab> */}
        {(vp || vvp) && (
          <Tab
            isActive={false}
            onClick={openBaziCalculator}
            title={t("account.downloadBazi", { defaultValue: "Bazi Calculator" })}
          >
            {t("account.downloadBazi", { defaultValue: "Bazi Calculator" })}
          </Tab>
        )}
      </Tabs>

      <Content>
        {activeTab === "accountInfo" && <AccountInfo />}
        {activeTab === "personalProfile" && <PersonalProfile onBack={handleGoBack} />}
        {activeTab === "addresses" && <Addresses />}
        {activeTab === "digitalcharm" && <DigitalCharm />}
        {activeTab === "purchasecoin" && <PurchaseCoins />}
        {activeTab === "interest" && <Interest />}
        {activeTab === "upcoming" && <UpConsultation />}
        {activeTab === "appointments" && <MyAppointment />}
        {activeTab === "chart" && <NatalChart />}
        {activeTab === "commission" && (
          <Commission
            VSTATUS={VSTATUS}
            commissionCoins={commissionCoins}
            gemCount={gemCount}
          />
        )}
        {/* New Tab Content */}
        {activeTab === "wallet" && <Wallet />}
        {activeTab === "plan" && <Plan />}
        {activeTab === "unsubscribe" && <Unsubscribe />}
      </Content>
    </Container>
  );
};

export default AccountPage;
